module.exports = __webpack_public_path__ + "img/client9.8c80c25f.svg";